'use client';

import { cn } from '@/shared/lib/cn';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Layout } from '@/shared/ui/layout';
import {
    ProductCardAddToCartButton,
    Icon as ProductCardAddToCartButtonIcon,
    Text as ProductCardAddToCartButtonText,
} from './product-card-add-to-cart-button';
import { ProductCardAvailability } from './product-card-availability';
import { ProductCardBottomOverlayWrapper } from './product-card-bottom-overlay-wrapper';
import { ProductCardContentWrapper } from './product-card-content-wrapper';
import { ProductCardDescription } from './product-card-description';
import { ProductCardImage } from './product-card-image';
import { ProductCardName } from './product-card-name';
import { ProductCardOriginalPrice } from './product-card-original-price';
import { ProductCardPrice } from './product-card-price';
import { ProductCardSelect } from './product-card-select';
import { ProductCardTags } from './product-card-tags';
import { ProductCardProps } from './types';

export const ProductCardTransparentVariant = ({
    tags,
    isImageVisible,
    imageUrl,
    isNameVisible,
    name,
    availability,
    description,
    isDescriptionVisible,
    variants,
    defaultVariantId,
    priceValues,
}: ProductCardProps) => {
    const getLocalizedValue = useGetLocalizedValue();
    const localizedName = getLocalizedValue(name);

    return (
        <>
            <ProductCardImage
                className={cn(
                    availability && !availability.isVisibleInImage && 'product-card__image--with-strip',
                )}
                localizedName={localizedName}
                isImageVisible={isImageVisible}
                imageUrl={imageUrl}
            >
                <ProductCardAvailability availability={availability} />
                <ProductCardBottomOverlayWrapper>
                    <ProductCardTags tags={tags} variant="inImage" />
                    <ProductCardAvailability availability={availability} variant="strip" />
                </ProductCardBottomOverlayWrapper>
            </ProductCardImage>
            <ProductCardContentWrapper>
                <ProductCardTags tags={tags} />
                <ProductCardName localizedName={localizedName} isNameVisible={isNameVisible} />
                <ProductCardDescription
                    description={description}
                    isDescriptionVisible={isDescriptionVisible}
                />
                <ProductCardSelect variants={variants} defaultVariantId={defaultVariantId} />
                <Layout>
                    <ProductCardPrice priceValues={priceValues} />
                    <ProductCardOriginalPrice priceValues={priceValues} />
                    <ProductCardAddToCartButton>
                        <ProductCardAddToCartButtonIcon />
                        <ProductCardAddToCartButtonText />
                    </ProductCardAddToCartButton>
                </Layout>
            </ProductCardContentWrapper>
        </>
    );
};
